import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface RadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface MuiRadioControlledProps {
  inputProps: {
    name: string;
    label?: string;
    defaultValue?: string;
    row?: boolean;
  };
  options: RadioOption[];
  styles?: any;
}

export function MuiRadioControlled({
  inputProps,
  options,
  styles = {},
}: MuiRadioControlledProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={inputProps.name}
      defaultValue={inputProps.defaultValue ?? ''}
      render={({ field }) => (
        <FormControl error={!!errors[inputProps.name]} sx={styles}>
          {inputProps.label && (
            <FormLabel id={`${inputProps.name}-label`}>
              {inputProps.label}
            </FormLabel>
          )}
          <RadioGroup
            row={inputProps.row ?? false}
            aria-labelledby={`${inputProps.name}-label`}
            {...field}
          >
            {options.map(option => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
                disabled={option.disabled}
              />
            ))}
          </RadioGroup>
          {errors[inputProps.name] && (
            <FormHelperText>
              {String(errors[inputProps.name]?.message)}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
